import {
  GET_MY_INCIDENTS,
  GET_MY_INCIDENTS_REFRESH_MAP,
  GET_MY_INCIDENTS_PROFILE,
  SAVE_MY_INCIDENTS_PROFILE,
  CLEAR_MY_INCIDENTS_PROFILE_ERROR,
  GET_MY_INCIDENTS_FILTERS,
} from "@/store/actions.type";
import {
  DELETE_MY_INCIDENT,
  SAVE_MY_INCIDENT,
  SET_MY_INCIDENTS,
  SET_MY_INCIDENTS_REFRESH_MAP,
  SET_MY_INCIDENTS_PROFILE,
  SET_MY_INCIDENTS_PROFILE_ERROR,
  SET_MY_INCIDENTS_FILTERS,
} from "@/store/mutations.type";
import {
  deleteMyIncident,
  getMyIncidents,
  saveMyIncident,
  getProfile,
  updateProfile,
} from "@/services/myIncidents/myIncidents.service";

const STATE = {
  refreshMap: false,
  incidents: [],
  profile: [],
  profileError: undefined,
  filters: {
    timestamp: undefined,
    search: undefined,
    startDate: undefined,
    endDate: undefined,
  },
};

const GETTERS = {
  incidents: (state) => state.incidents,
  refreshMap: (state) => state.refreshMap,
  profile: (state) => state.profile,
  profileError: (state) => state.profileError,
  filters: (state) => state.filters,
};

const ACTIONS = {
  async [GET_MY_INCIDENTS](context, params) {
    try {
      const results = await getMyIncidents(params);
      context.commit(SET_MY_INCIDENTS, results);
    } catch (error) {
      console.error("Error in GET_MY_INCIDENTS action: " + error);
    }
  },
  async [GET_MY_INCIDENTS_REFRESH_MAP](context, params) {
    context.commit(SET_MY_INCIDENTS_REFRESH_MAP, params);
  },
  [GET_MY_INCIDENTS_FILTERS](context, params) {
    context.commit(SET_MY_INCIDENTS_FILTERS, params);
  },
  async [GET_MY_INCIDENTS_PROFILE](context, params) {
    try {
      const results = await getProfile();
      context.commit(SET_MY_INCIDENTS_PROFILE, results);
    } catch (error) {
      console.error("Error in GET_MY_INCIDENTS_PROFILE action: " + error);
    }
  },
  async [SAVE_MY_INCIDENTS_PROFILE](context, params) {
    try {
      await updateProfile(params);
    } catch (error) {
      console.error("Error in SAVE_MY_INCIDENTS_PROFILE action: ", error);
      context.commit(SET_MY_INCIDENTS_PROFILE_ERROR, error.data.message);
    }
    try {
      const results = await getProfile();
      context.commit(SET_MY_INCIDENTS_PROFILE, results);
    } catch (error) {
      console.error("Error in GET_MY_INCIDENTS_PROFILE action: ", error);
      context.commit(SET_MY_INCIDENTS_PROFILE_ERROR, error.data.message);
    }
  },
  async [SAVE_MY_INCIDENT](context, params) {
    try {
      await saveMyIncident(params);
    } catch (error) {
      console.error("Error in SAVE_MY_INCIDENT action: " + error);
    }
  },
  async [DELETE_MY_INCIDENT](context, params) {
    try {
      await deleteMyIncident(params);
    } catch (error) {
      console.error("Error in DELETE_MY_INCIDENT action: " + error);
    }
  },
  [CLEAR_MY_INCIDENTS_PROFILE_ERROR](context) {
    context.commit(SET_MY_INCIDENTS_PROFILE_ERROR, undefined);
  },
};

const MUTATIONS = {
  [SET_MY_INCIDENTS](state, data) {
    state.incidents = data;
  },
  [SET_MY_INCIDENTS_REFRESH_MAP](state, data) {
    state.refreshMap = data;
  },
  [SET_MY_INCIDENTS_FILTERS](state, data) {
    state.filters = data;
  },
  [SET_MY_INCIDENTS_PROFILE](state, data) {
    state.profile = data;
  },
  [SET_MY_INCIDENTS_PROFILE_ERROR](state, data) {
    state.profileError = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
